// @flow
import React from "react";
import PageContainer from "../containers/PageContainer";
import NearbyConsultants from "../containers/NearbyConsultants" ;
import { useTranslation } from 'react-i18next';

export default function NearbyConsultantsView() {
    const { t } = useTranslation();
  return (
      <PageContainer title={t("Nearby Consultants")} showShopToolbar={true}>
        <div className="near-by-consultant-container">
          <NearbyConsultants />
          </div>
    </PageContainer>
  );
}
